<!--  -->
<template>
  <div>
    <div class="examples_rightbox">
      <div class="input_box">
        <div>标题：</div>
        <div><el-input v-model.trim="form.title" style="width: 300px;" placeholder="请输入标题" /></div>
        <!-- <div style="display:flex;align-items: center;">
          <div style="margin-left:10px;">
            随机标题：
          </div>
          <el-radio-group v-model="rand_title" class="serwr" size="mini" @change="changewrrr">
            <el-radio-button type="success" :label="1">随机</el-radio-button>
            <el-radio-button type="success" :label="0">不随机</el-radio-button>
          </el-radio-group>

        </div> -->
      </div>
      <!-- <div v-if="title_options.length!==0 && rand_title == 1" style="margin-top: 10px;margin-right: 30px;">
        <div style="font-size: 16px;margin-bottom: 5px;">随机标题:</div>
        <div style="margin-left: 40px;margin-top:10px">
          <div v-for="itemq,indexq in title_options" :key="indexq">
            <el-input v-model.trim="title_options[indexq]" style="width: 500px;margin-bottom: 10px;" placeholder="请输入内容" />
            <el-button type="danger" size="mini" style="margin-left:10px" @click="deater(1,indexq)">删除</el-button>
          </div>
        </div>
      </div> -->
      <div class="input_box">
        <div>链接：</div>
        <div><el-input v-model.trim="form.url" style="width:300px" placeholder="请输入链接" /></div>
      </div>
      <!-- <div class="input_box">
        <div>描述：</div>
        <div>
          <el-input v-model="form.description" style="width:300px" type="textarea" placeholder="请输入描述" />
        </div>

      </div> -->
      <!-- <div v-if="desc_options.length!==0 && rand_desc == 1" style="margin-top: 10px;">
        <div style="font-size: 16px;margin-bottom: 5px;margin-right: 2px;">随机描述:</div>
        <div style="margin-left: 40px;margin-top:10px;height: 270px;overflow: auto;">
          <div v-for="itemq,indexq in desc_options" :key="indexq">
            <el-input
              v-model.trim="desc_options[indexq]"
              type="textarea"
              :rows="5"
              style="width: 500px;margin-bottom: 10px;"
              placeholder="请输入内容"
            />
            <el-button type="danger" size="mini" style="margin-left:10px" @click="deater(2,indexq)">删除</el-button>
          </div>
        </div>
      </div> -->
      <div class="cover_box">
        <div>封面：</div>
        <el-button type="success" size="mini" @click="materiallibrary">选择封面</el-button>
      </div>
      <img v-if="form.testsrc" :src="form.testsrc" class="uopatatextimg">
    </div>
    <!-- <div style="display: flex;margin-top: 10px;">
      <div v-if="title_options.length!==0" class="cover_box" style="margin-top: 10px;margin-right: 30px;">
        <div style="font-size: 16px;margin-bottom: 5px;margin-right: 2px;">随机标题:</div>
        <div>
          <div v-for="itemq,indexq in title_options" :key="indexq">
            <el-input v-model="title_options[indexq]" style="width: 300px;margin-bottom: 10px;" placeholder="请输入内容" />
          </div>
        </div>
      </div>
      <div v-if="desc_options.length!==0" class="cover_box" style="margin-top: 10px;">
        <div style="font-size: 16px;margin-bottom: 5px;margin-right: 2px;">随机描述:</div>
        <div>
          <div v-for="itemq,indexq in desc_options" :key="indexq">
            <el-input v-model="desc_options[indexq]" style="width: 300px;margin-bottom: 10px;" placeholder="请输入内容" />
          </div>
        </div>
      </div>
    </div> -->

    <div style="margin-left:65px;margin-top:10px"><el-button type="primary" @click="sumbit">确定</el-button></div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
  </div>
</template>

<script>
import chooseimg from '../../menumanagement/components/chooseimg.vue'
// import { getMultiTitles } from '@/api/officialaccount.js'
export default {
  components: { chooseimg },
  data() {
    return {
      form: {
        title: '',
        url: '',
        // description: '',
        testsrc: '',
        // source_material_id: ''
        media_id: ''
      },
      dialogVisibletwo: false,
      rand_title: 1,
      title_options: [],

      rand_desc: 1,
      desc_options: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.form.testsrc = img
      // this.form.source_material_id = key
      // media_id
      this.form.media_id = key
    },

    send(item) {
      // eslint-disable-next-line eqeqeq
      if (JSON.stringify(item) == '{}') {
        console.log('item', item)
        if (this.rand_title === 1) {
          // this.seet()
        }
        if (this.rand_desc === 1) {
          // this.seetr()
        }
      } else {
        console.log('item1', item)
        this.form.title = item.title
        this.form.url = item.url
        // this.form.description = item.desc
        this.form.testsrc = item.picurl
        // media_id
        this.form.media_id = item.media_id
        // this.form.source_material_id = item.source_material_id
        // this.rand_title = item.rand_title
        this.title_options = item.title_options
        // this.rand_desc = item.rand_desc
        this.desc_options = item.desc_options
      }
    },
    sumbit() {
      if (this.form.title === '') {
        this.$message.error('请填写标题')
        return
      }
      if (this.form.url === '') {
        this.$message.error('请填写链接')
        return
      }
      const reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
      if (!reg.test(this.form.url)) {
        this.$message.error('请填写正确链接')
        return
      }
      // if (this.form.description === '') {
      //   this.$message.error('请填写描述')
      //   return
      // }
      if (this.form.testsrc === '') {
        this.$message.error('请选择封面')
        return
      }
      // if (this.rand_title === 1) {
      //   if (this.title_options.length === 0) {
      //     this.$message.error(`请完善要编辑替换的标题`)
      //     return
      //   }
      //   for (let i = 0; i < this.title_options.length; i++) {
      //     if (this.title_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的标题`)
      //       return
      //     }
      //   }
      // }
      // if (this.rand_desc === 1) {
      //   if (this.desc_options.length === 0) {
      //     this.$message.error(`请完善要编辑替换的描述`)
      //     return
      //   }
      //   for (let i = 0; i < this.desc_options.length; i++) {
      //     if (this.desc_options[i] === '') {
      //       this.$message.error(`请完善要编辑替换的描述`)
      //       return
      //     }
      //   }
      // }

      // rand_title: 1,
      // title_options: [],

      // rand_desc: 1,
      // desc_options: []

      this.$emit('callback', this.form, this.title_options, this.desc_options)
    }
    // titlblure() {
    //   console.log('失焦')
    //   this.seet()
    // },
    // desrblure() {
    //   console.log('失焦')
    //   this.seetr()
    // },
    // seet() {
    //   getMultiTitles({
    //     text: this.form.title
    //   }).then(res => {
    //     console.log('111', res)
    //     this.title_options = res.data
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }).catch(() => {
    //     this.title_options = []
    //   })
    // },
    // seetr() {
    //   getMultiTitles({
    //     text: this.form.description
    //   }).then(res => {
    //     console.log('111', res)
    //     this.desc_options = res.data
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }).catch(() => {
    //     this.desc_options = []
    //   })
    // },
    // changewrrr() {
    //   this.$nextTick(() => {
    //     this.$forceUpdate()
    //   })
    //   if (this.rand_title === 1) {
    //     this.seet()
    //   } else {
    //     this.title_options = []
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }
    // },
    // changew() {
    //   this.$nextTick(() => {
    //     this.$forceUpdate()
    //   })
    //   if (this.rand_desc === 1) {
    //     this.seetr()
    //   } else {
    //     this.desc_options = []
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }
    // },
    // deater(type, index) {
    //   if (type === 1) {
    //     this.title_options.splice(index, 1)
    //   } else {
    //     this.desc_options.splice(index, 1)
    //   }
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.examples_rightbox{
  margin-left: 30px;
}
.input_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.cover_box{
  display: flex;
  align-items: center;
}
.uopatatextimg{
  width: 80px;
  height: 80px;
  margin-top: 20px;
  margin-left: 40px;
}
.serwr /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner{
  background-color:#67C23A;
  border-color: #67C23A;
}
</style>
